<template>
  <div id="app" v-if="!$route.meta.refreshFlag">
    <van-pull-refresh v-model="isLoading" :head-height="150" @refresh="onRefresh" success-text="刷新成功" loading-text="正在努力的加载">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </van-pull-refresh>
  </div>
  <div id="app" v-else>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { PullRefresh } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      propt: "zssw",
	  style: "normal",
    };
  },

  mounted() {
	window.caringModel=this.caringModel;
    window.backData = this.backData;
    window.console.log("statusBarHeight" + this.backData);
  },
  created() {
	//this.$tool.callModule("getCaringModel");
    this.getUrlData();
    this.changeTheme();
  },
  methods: {
    backData(val = 0) {
      sessionStorage.setItem("statusBar", val);
      this.$store.commit("getStatusBarFlag");
    },
	caringModel(val){
	  window.document.documentElement.setAttribute("data-style", val);
	  console.log(val)
	},
    onRefresh() {
      setTimeout(() => {
        this.$toast("刷新成功");
        this.isLoading = false;
        window.location.reload();
      }, 100);
    },
    getUrlData() {
      let url = window.location.href;
      console.log(url.indexOf("app=") != -1);
      if (url.indexOf("app=") != -1) {
        let temp1 = url.split("#")[0];
        let temp2 = temp1.split("?")[1].split("&")[0].split("=")[1];
        this.propt = temp2;
      }
    },
    changeTheme() {
      window.document.documentElement.setAttribute("data-theme", this.propt);
    },
  },
  components: {
    [PullRefresh.name]: PullRefresh,
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-height: 100%;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  background: #f3f3f3;
}
html {
  color: rgb(10, 7, 7);
  background: #fff;
  overflow-y: scroll;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}
html * {
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
html,
body {
  font-family: sans-serif;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
textarea,
p,
blockquote,
th,
td,
hr,
button,
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  margin: 0;
  padding: 0;
}
input,
select,
textarea {
  font-size: 100%;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
fieldset,
img {
  border: 0;
}
abbr,
acronym {
  border: 0;
  font-variant: normal;
}
del {
  text-decoration: line-through;
}
address,
caption,
cite,
code,
dfn,
em,
th,
var {
  font-style: normal;
  font-weight: 500;
}
ol,
ul {
  list-style: none;
}
caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 500;
}
q:before,
q:after {
  content: "";
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
a:hover {
  text-decoration: underline;
}
html,
body {
  height: 100%;
}
ins,
a {
  text-decoration: none;
}
.index .van-grid-item__content {
  padding: 0 14px;
}
.van-pull-refresh {
  height: 100%;
  //	min-height: calc(100vh);
}
.van-pull-refresh__track {
  min-height: calc(100vh);
}
</style>
